module.exports = __webpack_public_path__ + "img/141.9.91522205.png";